<template>
    <div class="mx-auto mt-5">
        <div id="header-identificacao" class="row bg-light mb-2">
            <div class="col-sm-12 col-md-12">
                <fieldset class="form-group">
                    <div role="group" class="bv-no-focus-ring">
                        <label for="devedor">Devedor:</label>
                        <input id="devedor" type="text" readonly="readonly" :value="nomeDevedorFormatado()"
                               class="font-weight-bold form-control-plaintext">
                    </div>
                </fieldset>
            </div>
        </div>

        <hr class="mt-4"/>

        <p><b>Memória de Cálculo</b> (CDA (EF) - Valor de Base (VB) - Honorários (rateio))</p>

        <b-row style="max-height: 121px; overflow: auto;">
            <b-col md="6">
                <ul class="memoria mb-0">
                    <li v-for="item in listaItensRefis(1)">
                        <span class="mem-descricao">- CDA {{item.numeroDivida}} (EF {{item.cnj}}) - R$ {{item.valorBaseHonorarios | currency}}(VB) -  R$ {{obterValorRateio(item) | currency}} (rateio)</span>
                    </li>
                </ul>
            </b-col>
            <b-col md="6">
                <ul class="memoria mb-0">
                    <li v-for="item in listaItensRefis(2)">
                        <span class="mem-descricao">- CDA {{item.numeroDivida}} (EF {{item.cnj}}) - R$ {{item.valorBaseHonorarios | currency}}(VB) -  R$ {{obterValorRateio(item) | currency}} (rateio)</span>
                    </li>
                </ul>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6">
                <ul class="memoria mb-0 mt-2">
                    <li>
                        <b>Total: <span class="ml-4">R$ {{this.requisicao.valor}}</span></b>
                    </li>
                </ul>
            </b-col>
        </b-row>

        <b-row style="text-align: right; margin-top: -30px;">
            <b-col md="12">
                <b-button variant="outline-secondary" @click="exportarMemoria">
                    <i class="fas fa-print"></i> Imprimir Memória de Cálculo
                </b-button>
            </b-col>
        </b-row>

<!--    
		<hr v-if="requisicao.titularReceita == 1" class="mt-4"/>

        <b-row v-if="requisicao.titularReceita == 1">
            <b-col md="12">
                <p><b>Opções Complementares</b></p>
            </b-col>
            <div class="mr-3" style="padding-left: 15px;">
                <b-form-checkbox v-model="requisicao.emitirDocumentacao" id="emitirDocumentacao" name="check-button">
                    Enviar documentação gerada ao <b>E-mail</b>
                </b-form-checkbox>
            </div>
            <div class="campo-email col px-0 col">
                <b-form-input v-model="requisicao.emailEnviarDocumentacao" type="text" id="email" maxlength="100"
                              :class="'text-label'"
                              @keyup="requisicao.emailEnviarDocumentacao = removeSpecialCharactersGeralVirgula(requisicao.emailEnviarDocumentacao)"/>
            </div>
        </b-row>
-->
        <hr class="mt-4"/>

        <b-row>
            <b-col md="4">
                <b-form-group label="Informe o Setor responsável pela Requisição:"
                              label-for="valorindica"
                              class="text-label required">
                    <multiselect
                            class="multiselect-simple mb-3"
                            name="setor"
                            v-model="requisicao.setor"
                            :show-labels="false"
                            :options="dados.setoresFiltrados"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            :internal-search="false"
                            @search-change="searchChangeSetor"
                            placeholder="Selecione"
                            track-by="codSetor"
                            label="nome">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                    </multiselect>
                </b-form-group>
            </b-col>
            <b-col md="8">
                <b-col>
                    <label for="carregarArq">Anexar arquivo à Requisição (ex.: decisão judicial, garantia etc.) (opcional):</label>
                    <b-form-group id="input-group-1" label="" label-for="parcelamento">
                        <b-form-file id="carregarArq" v-model="arquivos" @input="realizarUpload"
                                     :class="!validations.arquivo.valid ? 'is-invalid' : ''"
                                     placeholder="Selecionar um arquivo"
                                     accept="image/png|image/jpeg|image/jpg|text/plain"></b-form-file>
                        <div v-if="!validations.arquivo.valid" class="invalid-message">Tamanho do arquivo ultrapassa o limite definido em 50mb.</div>
                    </b-form-group>
                </b-col>
            </b-col>
        </b-row>

        <b-row v-for="arquivo in requisicao.arquivos">
            <b-col md="4"></b-col>
            <b-col md="6" class="mt-1">
                <a class="link" style="margin-left: 30px;" @click="obterAnexo(arquivo)">
                    {{ arquivo.nomeArquivo }}
                </a>
                <b-button class="ml-2"
                          variant="outline-warning"
                          @click="excluirArquivo(arquivo)">
                    <i class="fa fa-trash"></i>
                </b-button>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row class="mt-1 align-items-center">
            <div class="px-3">
                <label class="text-bold">
                    Observações:
                    <span v-if="requisicao.titularReceita >= 1" class="text-danger">*</span>
            </label>
                <span v-if="requisicao.titularReceita >= 1">Indique abaixo as informações pertinentes à transferência de valores realizada para a conta da CES!</span>
            </div>
            <div class="col" v-if="!validations.observacao.valid">
                <div class="msg-observacoes mb-1 invalid-feedback d-block">
                    Como houve a edição de valor(es) de CDA na tela anterior, informe a razão ou o processo jud. (CNJ) ou administrativo (SID/NUP) que justificou a alteração!
                </div>
            </div>
        </b-row>
        <b-row class="mb-0">
            <b-col>
                <b-form-textarea
                        id="observacoes"
                        v-model="requisicao.observacoes"
                        size="500"
                        placeholder=""
                        max-rows="10"
                        :class="(!validations.observacao.valid || !validations.observacao.titularReceita ? 'is-invalid' : '')"
                ></b-form-textarea>
                <div v-if="!validations.observacao.titularReceita" class="invalid-message">O campo Observações é obrigatório.</div>
            </b-col>
        </b-row>
		
        <CompLoading ref="loading"/>
    </div>
</template>

<script>
    import axios from 'axios';
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompLoading from "../../shared/components/CompLoading";
    import ModalIncluirDevedor from "../../shared/components/ModalIncluirDevedor";

    export default {
        props: ['devedor','requisicao','acessoLimitado'],
        mixins: [ formatarMixins ],
        components: {CompLoading, ModalIncluirDevedor},
        data() {
            return {
                urlApi: null,
                token: null,
                arquivos: [],
                arquivosTemp: [],
                dados: {
                    setores: [],
                    setoresFiltrados: [],
                },
                validations: {
                    observacao: {
                        valid: true,
                        titularReceita: true
                    },
                    arquivo: { valid: true }
                }
            }
        },
        computed: {
            getTheme() {
                return this.$store.getters.getTheme
            },
        },
        methods: {
            nomeDevedorFormatado() {
                return this.requisicao.devedor.nome +
                    (this.requisicao.devedor.documento != null && this.requisicao.devedor.documento.length == 10 ? ' (CNPJ Raiz ' :
                        this.requisicao.devedor.documento != null && this.requisicao.devedor.documento.length <= 14 ? ' (CPF ' : ' (CNPJ ') +
                    this.requisicao.devedor.documento + ')';
            },
            listaItensRefis(part){
                let filterItems = [];
                for(let i = 0; i < this.requisicao.cdas.length; i++) {
                    if(this.requisicao.cdas[i].valorHonorarios >= 0) {
                        filterItems.push(this.requisicao.cdas[i]);
                    }
                }

                if(filterItems.length <= 5) {
                    return part == 1 ? filterItems : [];
                }

                if(filterItems.length < 10) {
                    let secondPart = filterItems.length - 5;
                    return part == 1 ? filterItems.slice(0, 5) : filterItems.slice(-secondPart);
                }

                let half = Math.ceil(filterItems.length / 2);

                return part == 1 ? filterItems.slice(0, half) : filterItems.slice(-half);
            },
            async obterAnexo(anexo) {
                if(anexo.base64 == null && anexo.codAnexo != null) {
                    await axios.get(`${this.urlApi}/v1/pesquisas/downloadAnexoBase64/${anexo.codAnexo}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        },
                    }).then(response => {
                        if(!response.data || response.data == null){
                            this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                            return;
                        }

                        var a = document.createElement("a");
                        a.href = response.data.base64;
                        a.download = response.data.nomeArquivo;
                        a.click();
                    }).catch((error) => {
                        this.exibirErro(error)
                    });
                } else {
                    var a = document.createElement("a");
                    a.href = anexo.base64;
                    a.download = anexo.nomeArquivo;
                    a.click();
                }
            },
            validarObservacao() {
                this.validations.observacao.valid = true;
                this.validations.observacao.titularReceita = true;
                
				if(this.requisicao.houveAlteracao && this.verificarValorVazio(this.requisicao.observacoes)) {
                    this.validations.observacao.valid = false;
					
                }  else if(this.requisicao.titularReceita >= 1 && this.verificarValorVazio(this.requisicao.observacoes)) {
                    this.validations.observacao.titularReceita = false;
                }

                return this.validations.observacao.valid && this.validations.observacao.titularReceita;
            },
            async exportarMemoria() {
                this.$refs.loading.showLoading();

                let requisicaoTemp = {
                    ... this.requisicao,
                    valor: this.tratarCamposNumericosFloat(this.requisicao.valor)
                };

                console.log(requisicaoTemp);

                axios.post(`${this.urlApi}/v1/comunicacaoTransfExecucaoFiscalSefa/exportarMemoriaCalculo`, requisicaoTemp, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    },
                    responseType: 'arraybuffer'
                })
                    .then(response => {
                        let blob = new Blob([response.data], { type: 'application/pdf' });
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'MemoriaCalculo.pdf';
                        link.click();
                    }).finally(() => {
                    this.$refs.loading.hideLoading();
                })
            },
            realizarUpload(arquivo) {
                this.validations.arquivo.valid = true;
                if(arquivo != null) {
                    let arquivoConvertido = null
                    if ((arquivo.size / 1024) / 1024 > 50.0) {
                        this.validations.arquivo.valid = false;
                    } else {
                        var reader = new FileReader()
                        reader.onload = function (e) {
                            arquivoConvertido = {
                                nomeArquivo: arquivo.name,
                                base64: e.target.result
                            }
                        }
                        reader.readAsDataURL(arquivo)
                        reader.onloadend = () => {
                            this.$emit('executeUpload', arquivoConvertido);
                            this.arquivos = [];
                            this.arquivosTemp.push(arquivoConvertido);
                        }
                    }
                }
            },
            excluirArquivo(arquivo) {
                const index = this.arquivosTemp.indexOf(arquivo);
                this.arquivosTemp.splice(index, 1);
                this.$emit('excluirArquivo', arquivo);
            },
            atualizarSetor() {
                if(this.requisicao.setor != null && this.requisicao.setor.codSetor != null) {
                    for(var i = 0; i < this.dados.setores.length; i++) {
                        if(this.requisicao.setor.codSetor == this.dados.setores[i].codSetor) {
                            this.requisicao.setor = this.dados.setores[i];
                        }
                    }
                }
            },
            async listarSetores() {
                axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/listarSetores`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                    this.dados.setores = response.data;
                    this.dados.setoresFiltrados = response.data;

                    this.atribuirSetorPadrao();
                })
            },
            atribuirSetorPadrao() {
                let userData = JSON.parse(this.$store.getters.getUser);
                if (userData.groups) {
                    for (let i = 0; i < userData.groups.length; i++) {
                        if(userData.groups[i] == 'SFEPGE-ADMINISTRATIVO') {
                            for (let j = 0; j < this.dados.setores.length; j++) {
                                if(this.dados.setores[j].nome.includes("Coordenadoria de Assuntos Fiscais")) {
                                    this.requisicao.setor = this.dados.setores[j];
                                }
                            }
                        }
                    }
                }
            },
            async obterAnexo(anexo) {
                if(anexo.base64 == null && anexo.codAnexo != null) {
                    await axios.get(`${this.urlApi}/v1/pesquisas/downloadAnexoBase64/${anexo.codAnexo}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        },
                    }).then(response => {
                        if(!response.data || response.data == null){
                            this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                            return;
                        }

                        var a = document.createElement("a");
                        a.href = response.data.base64;
                        a.download = response.data.nomeArquivo;
                        a.click();
                    }).catch((error) => {
                        this.exibirErro(error)
                    });
                } else {
                    var a = document.createElement("a");
                    a.href = anexo.base64;
                    a.download = anexo.nomeArquivo;
                    a.click();
                }
            },
            salvar() {
                this.$emit('salvar', true);
            },
            obterValorRateio(item) {
                let totalHonorarios = 0;
                for(let i = 0; i < this.requisicao.cdas.length; i++) {
                    totalHonorarios = this.toFixed(totalHonorarios + this.requisicao.cdas[i].valorHonorarios);
                }
                return this.toFixed(this.toFixed((this.tratarCamposNumericosFloat(this.requisicao.valor) / totalHonorarios)) * item.valorHonorarios);
            }
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;
            this.listarSetores();
            this.requisicao.titularReceita = 1;

        }
    }
</script>

<style scoped>
    .memoria {
        list-style: none;
    }

    .mem-descricao {
        text-align: right;
    }

    .mem-total {
        text-align: right;
        font-weight: 700;
    }
</style>